import {createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl } from '../../boot/index.js';

export const getTeleRoles = createAsyncThunk("/get-tele-sales", async (data) => {
    const token = localStorage.getItem("authToken")
    try {
        const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-tele-sales`, data, { 
            headers: {
                "auth-token": token,
            }
        });
        return response;
    } catch (error) {
        console.error('Error fetching Vendor - ', error);
        throw error;
    }
})